<template>
    <div class="error-page">
        <h1>Sorry, The Site Cannot Be Reached!</h1>
        <bull-loader />
    </div>
</template>

<script>
import BullLoader from '@/components/ReusableComponents/BullLoader/BullLoader.vue'
export default {
    components: {
        BullLoader,
    }
}
</script>

<style lang="scss" scoped>
    h1 {
        display: block;
        text-align: center;
        margin: 150 * $rem 0;
        letter-spacing: 2 * $rem;
    }

    /deep/ img {
        width: 500 * $rem;
        height: 500 * $rem;
    }
</style>